module.exports = __webpack_public_path__ + "img/yg_pic.927d8674.png";